import React, { useEffect, useState } from 'react'
import { useRecoilValue, useRecoilState } from 'recoil'
import { globalStream } from 'src/atom/GlobalStream'
import { useNavigate } from 'react-router-dom'
import LogoHeader from 'src/components/header/LogoHeader'

const RegistrationInstruction = () => {
  const [GSteam, setGlobalSteam] = useRecoilState(globalStream)
  const [isChecked, setIsChecked] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const counsellingName = useRecoilValue(globalStream).counsellingName

  const handleCheckChange = (e) => {
    setIsChecked(e.target.checked)
  }

  useEffect(() => {
    if (GSteam.counsellingName === 'UG') {
      setGlobalSteam((prevGlobalSteam) => ({
        ...prevGlobalSteam,
        counsellingName: 'UG',
      }))
    }

    if (GSteam.counsellingName === 'PG') {
      setGlobalSteam((prevGlobalSteam) => ({
        ...prevGlobalSteam,
        counsellingName: 'PG',
      }))
    }
  }, [GSteam.counsellingName, setGlobalSteam])

  useEffect(() => {
    if (!counsellingName) {
      navigate('/homepage')
    }
  }, [counsellingName, navigate])

  const courseName =
    GSteam.counsellingName === 'UG' ? 'BAMS/BHMS' : 'MD/MS (Ayurveda)'

  const examName =
    GSteam.counsellingName === 'UG' ? 'NEET UG' : 'AIAPGET'

  return (
    <>
      <div className="container-fluid" style={{ padding: '10px 20px' }}>
        <LogoHeader />

        <div
          className="mt-2 d-flex justify-content-center align-items-center"
          style={{
            fontWeight: 'bold',
            fontSize: '25px',
            textAlign: 'center',
          }}
        >
          Online Application Form for Admission to {courseName} Courses
          2026-27
        </div>

        <div className="card ms-5 me-5 mt-3">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <strong>Instructions Before Filling the Application Form:</strong>
              </div>
            </div>

            <hr />

            <div className="row mt-2">
              <div className="col-sm-12">
                <ul>
                  <li>
                    Please keep your <strong>{examName} 2026 Score Card</strong>{' '}
                    ready before filling the application form.
                  </li>

                  <li>
                    Candidates must carefully read the{' '}
                    <strong>
                      official admission notification for {courseName} courses
                    </strong>{' '}
                    for the session 2026-27 before filling the application
                    form.
                  </li>

                  <li>
                    Candidates must ensure that all information provided in the
                    application form is correct and complete. Any concealment of
                    information or submission of incorrect information may lead
                    to cancellation of candidature without further notice.
                  </li>

                  <li>
                    For further information and updates, candidates are advised
                    to visit the official website{' '}
                    <a
                      href="https://www.skau.ac.in"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="blue-link"
                    >
                      www.skau.ac.in
                    </a>
                    .
                  </li>
                </ul>

                <div className="ms-3 form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="check1"
                    checked={isChecked}
                    onChange={handleCheckChange}
                    required
                  />

                  <label
                    className="ms-2 form-check-label"
                    htmlFor="check1"
                  >
                    Yes, I have read and understood the relevant Government of
                    Haryana notification and all the instructions for the
                    admission process for the year 2026.
                  </label>
                </div>

                <hr />

                <div className="m-3 text-left form-group">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => {
                      navigate('/onboarding-registration')
                    }}
                    disabled={!isChecked || loading}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      'Proceed'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          .blue-link {
            color: blue;
            text-decoration: underline;
          }
        `}
      </style>
    </>
  )
}

export default RegistrationInstruction